import React from 'react';
import { useTranslation } from 'react-i18next';
import './menu.css';
import logo from '../../assets/qfc_logo_main.svg';
import LanguageDropdown from './language_dropdown';
import ChevronDown from '../../assets/chevron-down.svg';


function Header() {
  const { t } = useTranslation();

  const [menuOpen, setMenuOpen] = React.useState(false);
  const [mobileSolutionsOpen, setMobileSolutionsOpen] = React.useState(false);
  const toggleMenu = () => {
    setMenuOpen((prev) => {
      const next = !prev;
      if (!next) setMobileSolutionsOpen(false);
      return next;
    });
  };

  const [solutionsOpen, setSolutionsOpen] = React.useState(false);
  const solutionsRef = React.useRef(null);

  React.useEffect(() => {
    const handleClickOutside = (e) => {
      if (solutionsRef.current && !solutionsRef.current.contains(e.target)) {
        setSolutionsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="App-menu-wrapper">
      <div className="App-menu">
        <div className="app-menu-items">
          <a href="/" tabIndex="1">
            <img src={logo} className="app-logo" alt="logo" />
          </a>
          <div className="solutions-dropdown" ref={solutionsRef}>
            <button
              type="button"
              className="solutions-button"
              onClick={() => setSolutionsOpen((v) => !v)}
              aria-haspopup="menu"
              aria-expanded={solutionsOpen}
            >
              <span>{t('common.solutions', 'Our offering')}</span>
              <img
                src={ChevronDown}
                alt=""
                aria-hidden="true"
                className={`chevron-icon ${solutionsOpen ? 'rotate' : ''}`}
              />
            </button>

            {solutionsOpen && (
              <div className="solutions-popover" role="menu">
                <a href="/#about" className="solutions-item" role="menuitem" tabIndex="1">
                  <div className="solutions-item-title">{t('common.solutionsMenu.qfc.title')}</div>
                  <div className="solutions-item-sub">{t('common.solutionsMenu.qfc.sub')}</div>
                </a>
                <a href="/utbildningar" className="solutions-item" role="menuitem" tabIndex="1">
                  <div className="solutions-item-title">{t('common.solutionsMenu.educations.title')}</div>
                  <div className="solutions-item-sub">{t('common.solutionsMenu.educations.sub')}</div>
                </a>
              </div>
            )}
          </div>
          <a href="/plans" tabIndex="1">{t('plans.title')}</a>
          <a href="/demo" tabIndex="1">{t('common.bookDemo')}</a>
          <a href="/contact" tabIndex="1">{t('common.contact')}</a>
        </div>

        <div className='flex'>
          <LanguageDropdown />
          <div className="app-menu-buttons">

            <a href="https://app.qualityfoodcontrol.com/" className="button-secondary small" tabIndex="1">
              {t('common.logIn')}
            </a>
            <a href="/plans" className="button-primary small" tabIndex="1">
              {t('common.getAccess')}
            </a>
          </div>

          <div className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={toggleMenu} aria-label="Toggle menu" aria-expanded={menuOpen} role="button">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        </div>



        <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
          <div className="mobile-menu-header">
            <img src={logo} alt="QFC logo" className="mobile-menu-logo" />
          </div>

          <div className="mobile-menu-content">
            <LanguageDropdown />

            <button
              type="button"
              className="mobile-menu-accordion-trigger"
              onClick={() => setMobileSolutionsOpen((v) => !v)}
              aria-expanded={mobileSolutionsOpen}
              aria-controls="mobile-solutions-accordion"
            >
              <span>{t('common.solutions', 'Our offering')}</span>
              <span className="mobile-menu-accordion-chevronWrap" aria-hidden="true">
                <img
                  src={ChevronDown}
                  alt=""
                  className={`mobile-menu-accordion-chevron ${mobileSolutionsOpen ? 'rotate' : ''}`}
                />
              </span>
            </button>

            {mobileSolutionsOpen && (
              <div className="mobile-menu-accordion-content" id="mobile-solutions-accordion">
                <a href="/#about" onClick={toggleMenu}>{t('common.solutionsMenu.qfc.title')}</a>
                <div className="mobile-menu-section-sub">{t('common.solutionsMenu.qfc.sub')}</div>

                <a href="/utbildningar" onClick={toggleMenu}>{t('common.solutionsMenu.educations.title')}</a>
                <div className="mobile-menu-section-sub">{t('common.solutionsMenu.educations.sub')}</div>
              </div>
            )}

            <a href="/plans" onClick={toggleMenu}>{t('plans.title')}</a>
            <a href="/demo" onClick={toggleMenu}>{t('common.bookDemo')}</a>
            <a href="/contact" onClick={toggleMenu}>{t('common.contact')}</a>

            <div className="app-menu-buttons">
              <a href="https://app.qualityfoodcontrol.com/" className="button-secondary small" onClick={toggleMenu}>{t('common.logIn')}</a>
              <a href="/plans" className="button-primary small" onClick={toggleMenu}>{t('common.getAccess')}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;